import { CubeSchemaTables } from 'cube'

import { OpportunitiesTableRow } from 'layouts/RevenueReport/RevenueReport.types'

export type OpportunityTimelineProps = {
  opportunity: OpportunitiesTableRow | null
  onClose: () => void
  isLoadingTableData: boolean
  onPrevItem: () => void
  onNextItem: () => void
}

export type UseOpportunityTimelineProps = {
  opportunityId: string
}

export interface IOpportunityTimelineTableRow {
  playbookId: string
  playbookName: string
  conversationId: string
  eventType: string
  eventDateAtWithZone: string
  eventDateAt: string
  opportunityId: string
  opportunityType: string
  opportunityDomain: string
  opportunityCreatedAt: string
  opportunityCreatedAtWithZone: string
  endUserEmail: string
  endUserDisplayName: string
  agentDisplayName: string
  leadCaptureSource: string
}

export type OpportunitiesTableDataResultMetric = {
  [CubeSchemaTables.DRIFT_CHAT_OPPORTUNITY_EVENTS]: {
    opportunityId: string
    eventType: string
    eventDateAtWithZone: string
    eventDateAt: string
    opportunityDomain: string
    opportunityType: string
    opportunityCreatedAt: string
    opportunityCreatedAtWithZone: string
    contactMail: string
    contactDisplayName: string
    meetingBookedByAgentName: string
    leadCaptureSource: string
  }
  [CubeSchemaTables.CONVERSATIONS]: {
    conversationId: string
    playbookId: string
  }
  [CubeSchemaTables.PLAYBOOKS]: {
    name: string
  }
}

export type TimelineEvent = {
  date: string | null
  component: React.ReactNode
}

export const TimelineEventOptions = {
  LEAD_CAPTURED: 'LEAD_CAPTURED_AT',
  MEETING_BOOKED: 'MEETING_BOOKED_AT',
  CONVERSATION_CREATED: 'CONVERSATION_CREATED_AT',
}
